// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"c71f697528590a9e06ca","263":"73803a8d9d4f3ba312b4","791":"d1c2977d992ea2bd0471"}[chunkId] + ".js";
};